(function() {
  const FONT_SIZE = '12px';
  const LINE_HEIGHT = '1.2';

  function resizeDrawerText() {
    const nav = document.querySelector('.menu-drawer__navigation');
    if (!nav) return;

    // Override CSS variables inline
    nav.style.setProperty('--menu-top-level-font-size', FONT_SIZE, 'important');
    nav.style.setProperty('--menu-top-level-font-line-height', LINE_HEIGHT, 'important');

    // Force the spans themselves as backup
    nav.querySelectorAll('.menu-drawer__menu-item-text.wrap-text').forEach(el => {
      el.style.setProperty('font-size', FONT_SIZE, 'important');
      el.style.setProperty('line-height', LINE_HEIGHT, 'important');
    });
  }

  // Run when drawer is toggled
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-header-drawer-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        // Delay to allow drawer to build
        setTimeout(resizeDrawerText, 50);
      });
    });
  });

})();
